export const GET_OWNERSHIP_URL = '/ownership';
export const SEARCH_OWNERSHIP_URL = '/ownership/search';
export const EXPORT_OWNERSHIP_URL = '/ownership/export';
export const GET_OWNERSHIP_DETAILS_URL = (id) => `/ownership/${id}`;
export const CREATE_OWNERSHIP_URL = '/ownership';
export const UPDATE_OWNERSHIP_URL = (id) => `/ownership/${id}`;
export const DELETE_OWNERSHIP_URL = (id) => `/ownership/${id}`;
